module.exports = __webpack_public_path__ + "img/DT.1cca5c49.png";